import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../../modules/shared/services/local-data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "asset-display-config",
    templateUrl: "./asset-display-config.html",
    providers: []
})
export class AssetDisplayConfigView implements OnInit {
    assetList: Array<any> = [];
    baseUrl = "";
    assetSetUp: any = {};

    constructor(
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            if(!this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].hasOwnProperty('assetConfig')) {
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                    this.sharedService.expansionStyle
                ].assetConfig.assetSetUp = this.sharedService.assetConfig.assetSetUp;
            }
            
            this.assetSetUp = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].assetConfig.assetSetUp;
            
        }
    }
}
